import URLS from '@/server/urls';
import { POST } from '@/server/http';

export default async ({
    tbId = 0,
    search = '',
    filters = [],
    sorts = [],
}, options = { showError: true }) => {
    const [ content, error, status ] = await POST(`${URLS.das.utableData.getAllList}/${tbId}`, {
        search,
        filters,
        sorts,
    }, options);
    if (error) return { error, status };
    return content || {};
};
